import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  ViberIcon,
  ViberShareButton,
} from "react-share";
import "./style.scss";
import {
  KYMDAN_SPECIAL_DELUXE_PILLOW_PREFIX,
  MESSENGER_URL,
  PHONE_CONTACT,
  ROUTER_PATH,
  WIDTH_IPAD,
} from "../../common/constant";
import { useSelector } from "react-redux";
import { selectGift } from "../../redux/reducers/slice/common";
import { ShareZalo } from "../share";
import { useLocation } from "react-router-dom";
import PopupPromotion from "../popupPromotion";
import * as GTM from "../tracking/GTM";
import { useTranslation } from "react-i18next";
import {
  IconChat,
  IconHotline,
  IconPhone,
  IconShare,
  IconTools,
} from "../images";
import queryString from "query-string";
import { useComponentVisible } from "../../hooks/useIsComponentVisble";
import { shortenUrl } from "../../utils/shortUrl";

const ContactAndShare = (props: any) => {
  const { t } = useTranslation();
  const refPopup = useRef<any>(null);
  const gift: any = useSelector(selectGift);
  const { pathname, search } = useLocation();
  const [url, setUrl] = useState("");
  const [hiddenShareItems, setHiddenShareItems] = useState(true);
  const [isShowItems, setIsShowItems] = useState(false);
  const [isSpecialMattressPage, setIsSpecialMattressPage] = useState(false);
  const { innerWidth } = window;
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const getDeviceType = useCallback(() => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    return "desktop";
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadShortUrl = async () => {
      try {
        const shortUrl = await shortenUrl(window.location.href);
        if (isMounted) {
          setUrl(shortUrl);
        }
      } catch (err) {
        console.log("shortenUrl error:", err);
        if (isMounted) {
          setUrl(window.location.href);
        }
      }
    };

    loadShortUrl();

    const _path = pathname.split("/");
    const parseQuery = queryString.parse(search);
    const checkPath = _path.length
      ? _path.filter(
          (p) =>
            `/${p}` === t(ROUTER_PATH.SPECIAL_MATTRESS) ||
            p.includes(KYMDAN_SPECIAL_DELUXE_PILLOW_PREFIX)
        )
      : [];

    if (
      checkPath.length ||
      (parseQuery[t("detail_query")] &&
        parseQuery[t("detail_query")]?.includes(
          KYMDAN_SPECIAL_DELUXE_PILLOW_PREFIX
        ))
    ) {
      setIsSpecialMattressPage(true);
    } else {
      setIsSpecialMattressPage(false);
    }

    return () => {
      isMounted = false;
    };
  }, [pathname, search]);

  const handleClickItem = (e: any) => {
    e.preventDefault();
    setHiddenShareItems(!hiddenShareItems);
  };

  const handleClickContactHotline = () => {
    GTM.trackingEventDynamic("clickContactHotline");
    setHiddenShareItems(true);
  };

  const handleClickPromotion = (e: any) => {
    e.preventDefault();
    if (refPopup && !isSpecialMattressPage) {
      refPopup.current.handleVisibleModal(true, gift && gift.url);
    } else if (isSpecialMattressPage) {
      window.location.href = "tel://" + PHONE_CONTACT;
    }
  };

  useEffect(() => {
    setIsShowItems(isComponentVisible);

    if (!isComponentVisible) {
      setHiddenShareItems(true);
    }
  }, [isComponentVisible]);

  const imgUrl = isSpecialMattressPage
    ? IconHotline
    : (gift &&
        gift.images.length &&
        gift.images[0].galaries.length &&
        gift.images[0].galaries[0].path) ||
      "";

  return (
    <div ref={ref}>
      <PopupPromotion ref={refPopup} />
      <input
        type="checkbox"
        id="click"
        hidden
        checked={isShowItems}
        onClick={() => {
          setHiddenShareItems(true);
          if (innerWidth <= WIDTH_IPAD) {
            setIsComponentVisible(!isComponentVisible);
          }
        }}
      />
      <span
        className="overlay-gift"
        onClick={(e: any) => handleClickPromotion(e)}>
        <img src={imgUrl} alt="" />
      </span>
      <label
        className="kd-contact-share-wrap"
        htmlFor="click"
        onMouseOver={() => {
          if (innerWidth > WIDTH_IPAD) {
            setIsShowItems(true);
          }
        }}
        onMouseLeave={(e: any) => {
          if (innerWidth > WIDTH_IPAD) {
            setIsShowItems(false);
            setHiddenShareItems(true);
          }
        }}>
        <span className="contact-share-parent">
          <img src={IconTools} alt="" />
        </span>
        <a
          href={`tel:${PHONE_CONTACT}`}
          onClick={() => handleClickContactHotline()}>
          <span className="contact-share-item">
            <img src={IconPhone} alt="" />
          </span>
        </a>
        <a href={MESSENGER_URL} target="_blank">
          {" "}
          <span className="contact-share-item">
            <img src={IconChat} alt="" />
          </span>
        </a>

        <a onClick={(e: any) => handleClickItem(e)}>
          <div className="share-items" hidden={hiddenShareItems}>
            <FacebookShareButton
              className="btn-share-item-wrapper"
              url={url}
              hashtag="#kymdan">
              <FacebookIcon size={40} borderRadius={50} />
            </FacebookShareButton>
            {getDeviceType() === "mobile" ? (
              <button
                className="react-share__ShareButton btn-share-item-wrapper btn-share-item-wrapper--mobile"
                onClick={() => {
                  window.location.href =
                    "fb-messenger://share?link=" +
                    encodeURIComponent(`${url}`) +
                    "&app_id=" +
                    encodeURIComponent(763482947504179);
                }}>
                <FacebookMessengerIcon size={40} borderRadius={50} />
              </button>
            ) : (
              <FacebookMessengerShareButton
                className="btn-share-item-wrapper"
                appId="763482947504179"
                url={url}>
                <FacebookMessengerIcon size={40} borderRadius={50} />
              </FacebookMessengerShareButton>
            )}

            <ShareZalo url={url} />
            <EmailShareButton
              className="btn-share-item-wrapper"
              subject={"KYMDAN STORE"}
              url={url}>
              <EmailIcon size={40} borderRadius={50} />
            </EmailShareButton>
            <ViberShareButton
              className="btn-share-item-wrapper"
              title={"KYMDAN STORE"}
              url={url}>
              <ViberIcon size={40} borderRadius={50} />
            </ViberShareButton>
          </div>
          <span className="contact-share-item">
            <img src={IconShare} alt="" />
          </span>
        </a>
      </label>
    </div>
  );
};

export default ContactAndShare;
